export enum MCStatus {
  Invited = 'invited',
  Rejected = 'rejected',
  Activated = 'activated',
  Deactivated = 'deactivated',
}
